module.exports = __webpack_public_path__ + "static/img/上海分部背景@2x.4f99b0d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/上海分部背景@2x.png
// module id = kior
// module chunks = 0